import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setTokenGetter } from '../lib/api';

/**
 * Wires Clerk's getToken into the apiFetch module.
 * Must be rendered inside ClerkProvider (e.g., in main.tsx or a layout).
 */
export function useApiToken() {
  const { getToken } = useAuth();

  useEffect(() => {
    setTokenGetter(() => getToken());
  }, [getToken]);
}
